<template lang="pug">
  .component-create-entity-button
    ModalReveal
      a.fa-stack.fa-lg(slot="trigger")
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      h2 Create new document requirement
      .row
        .columns
          label Select entity

            select(v-model="entity")
              option(v-if = "options.length" v-for="value in options" :value="value") {{ value }}

          selectize-category(v-if="entity ==='VehicleCategory'", @optionSelected="entitySelected")
          selectize-plan(v-if="entity ==='Plan'", @optionSelected="entitySelected")
          selectize-client-type(v-if="entity ==='ClientType'", @optionSelected="entitySelected")
        .columns()
          label Document type
            SelectizeDocumentType(:max-items="1", @optionSelected="documentTypeSelected")
          label Document group
            input(type="text", v-model="body.document_group")

      .row.columns.text-center
        button.button(@click="save") Save Document Type
</template>
<script type="text/babel">
  import ModalReveal from '../../foundation/ModalReveal'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import SelectizeDocumentType from '../lists/selectize/SelectizeDocumentType'
  import SelectizeCategory from '../lists/selectize/SelectizeCategory'
  import SelectizePlan from '../lists/selectize/SelectizePlan'
  import SelectizeClientType from "../lists/selectize/SelectizeClientType";

  export default {
    name: 'CreateDocumentRequirementButtonModal',
    components: {SelectizeClientType, SelectizePlan, SelectizeCategory, SelectizeDocumentType, ModalReveal},
    data() {
      return {
        entity: null,
        entityId: null,
        entity_type: null,

        body: {
          "entity_type": null,
          "entity_id": null,
          "document_type_id": null,
          "document_group": null
        },
        options: []
      }
    },
    created() {
      this.loadEntity()
    },
    methods: {
      documentTypeSelected(obj) {
        //this.body.document_types.push(obj.id)
        this.body.document_type_id = obj.id
      },
      entitySelected(obj) {
        //this.entityId = obj
        this.body.entity_id = obj.id
        this.body.entity_type = this.capitalize(this.entity)
      },

      capitalize(s) {
        return s.split('_').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join('')
      },
      loadEntity() {
        KeplerBackofficeSdk.documentRequirements.entityAllowed().entityList((data) => {
          this.options = data

        })
      },
      save() {
        KeplerBackofficeSdk.documentRequirements.make(this.body, () => {
          window.location.reload()
        })
      }
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateDocumentRequirementButtonModal.vue?3afcd7d8